import { render, staticRenderFns } from "./storeCouponList.vue?vue&type=template&id=02deabca&scoped=true&"
import script from "./storeCouponList.vue?vue&type=script&lang=js&"
export * from "./storeCouponList.vue?vue&type=script&lang=js&"
import style0 from "./storeCouponList.vue?vue&type=style&index=0&id=02deabca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02deabca",
  null
  
)

export default component.exports